import { GainType, RuleId } from "@/data/types";

/**
 * A rule is a plain special Rule that is part of a unit or weapon
 */
export default class ArmyBookRule {
  public readonly type = GainType.Rule;
  public id: RuleId = "";
  public name = "";
  public rating = undefined;
  public isConsumable = undefined;

  constructor(
    id: RuleId,
    name: string,
    rating: string | number = undefined,
    isConsumable: boolean = undefined
  ) {
    this.id = id;
    this.name = name;
    this.rating = rating;
    this.isConsumable = isConsumable;
  }

  static Parse(x) {
    if (!x) return null;
    if (typeof x === "string") {
      return this.FromString(x);
    }
    return this.FromObject(x);
  }

  static FromObject(json: { id?: RuleId; name: string; rating?: number | string; isConsumable?: boolean }) {
    if (!json) return null;
    return new ArmyBookRule(json.id, json.name, json.rating, json.isConsumable);
  }

  static FromString(ruleString) {
    const match =
      /^(?<name>[\w\d \-&\\']+?[\w\d])\(?(?<modify>\+?)(?<rating>[\d]*)\)?\s?(?<condition>in melee|when shooting)?$/gim.exec(
        ruleString
      );
    if (match) {
      const { name, rating } = match.groups;
      return new ArmyBookRule("", name, rating);
    }
    console.warn(`ArmyBookRule: Could not parse`, ruleString);
    return null;
  }

  static Is(ruleString) {
    return !!/^(?<name>[\w\d \-&\\']+?[\w\d])\(?(?<modify>\+?)(?<rating>[\d]*)\)?\s?(?<condition>in melee|when shooting)?$/gim.exec(
      ruleString
    );
  }

  toString() {
    return `${this.name}${this.rating ? `(${this.rating})` : ""}`;
  }
}
